import { Conversation } from "@/pages/Private/pages/Apollo/schema/get-people";
import { ListPersonSchedule } from "@/pages/Private/pages/List/schema/list";

/**
 * Resolves the `scheduledFor` date string for a conversation.
 *
 * Priority:
 * 1. `conversation.scheduledFor` if present
 * 2. The matching `Schedule` record (where `schedule.conversationId === conversation.id`) from the
 *    listPerson's `schedules` array, if available
 * 3. `null` — message is scheduled but the concrete time is not yet known (e.g. gated)
 */
export function resolveScheduledFor(
	conversation: Pick<Conversation, "id" | "scheduledFor">,
	schedules?: ListPersonSchedule[]
): string | null {
	if (conversation.scheduledFor) {
		return conversation.scheduledFor;
	}

	if (schedules?.length) {
		const match = schedules.find((s) => s.conversationId === conversation.id);

		if (match?.scheduledFor) {
			return match.scheduledFor;
		}
	}

	return null;
}
